import { render, staticRenderFns } from "./TeacherGeneralFormView.vue?vue&type=template&id=47e2f6da&scoped=true"
import script from "./TeacherGeneralFormView.vue?vue&type=script&lang=js"
export * from "./TeacherGeneralFormView.vue?vue&type=script&lang=js"
import style0 from "./TeacherGeneralFormView.vue?vue&type=style&index=0&id=47e2f6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2f6da",
  null
  
)

export default component.exports